import { graphql, useStaticQuery } from 'gatsby';
import { Kfh_PropertySearchMetaType } from '../types/graphqlTypes';

export const useSearchMeta = (): Kfh_PropertySearchMetaType => {
  const { kfhPropertySearchMeta } = useStaticQuery(
    graphql`
      query GET_BASIC_SEARCH_META {
        kfhPropertySearchMeta: kfhPropertySearchMetaType {
          resaleLowestPriceSterling {
            id
            name
            value
            selected
          }
          resaleLowestPriceEuro {
            id
            name
            value
            selected
          }
          resaleLowestPriceDollar {
            id
            name
            value
            selected
          }
          resaleHighestPriceSterling {
            id
            name
            value
            selected
          }
          resaleHighestPriceEuro {
            id
            name
            value
            selected
          }
          resaleHighestPriceDollar {
            id
            name
            value
            selected
          }
          rentalLowestPriceSterling {
            id
            name
            value
            selected
          }
          rentalLowestPriceEuro {
            id
            name
            value
            selected
          }
          rentalLowestPriceDollar {
            id
            name
            value
            selected
          }
          rentalHighestPriceSterling {
            id
            name
            value
            selected
          }
          rentalHighestPriceEuro {
            id
            name
            value
            selected
          }
          rentalHighestPriceDollar {
            id
            name
            value
            selected
          }
          rentalLowestWeeklyPriceSterling {
            id
            name
            value
            selected
          }
          rentalLowestWeeklyPriceEuro {
            id
            name
            value
            selected
          }
          rentalLowestWeeklyPriceDollar {
            id
            name
            value
            selected
          }
          rentalHighestWeeklyPriceSterling {
            id
            name
            value
            selected
          }
          rentalHighestWeeklyPriceEuro {
            id
            name
            value
            selected
          }
          rentalHighestWeeklyPriceDollar {
            id
            name
            value
            selected
          }
          bedroomsMinimum {
            id
            name
            value
            selected
          }
          bedroomsMaximum {
            id
            name
            value
            selected
          }
          sortbyOptions {
            id
            name
            value
            selected
            query
          }
          perPage {
            id
            name
            value
            selected
          }
          furnishState {
            id
            name
            value
            selected
          }
          radius {
            id
            name
            value
            selected
          }
          commercialMinimumSize {
            id
            name
            value
            selected
          }
          commercialMaximumSize {
            id
            name
            value
            selected
          }
        }
      }
    `
  );

  return kfhPropertySearchMeta;
};
